// extracted by mini-css-extract-plugin
export default {"FormInput":"Textarea_FormInput__3IgE2","invalid":"Textarea_invalid__BDJSa"};